import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { DragDropComponent } from '../../../drag-drop/drag-drop.component';
import { MatTableModule } from '@angular/material/table';
import { StorageService } from 'src/app/core/storage/storage.service';
import { User } from 'src/app/shared/model/user.model';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataEntryService } from 'src/app/core/services/data-entry.service';

@Component({
  standalone: true,
  selector: 'app-step-documentation',
  templateUrl: './step-documentation.component.html',
  styleUrls: ['./step-documentation.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatStepperModule,
    CdkStepperModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class StepDocumentationComponent {
  @Input() stepper!: MatStepper;
  @Output() backStepEmitter = new EventEmitter();
  @Output() sendRequestEmitter = new EventEmitter<any>();

  user!: User;
  nisTimestamp = '';
  documentsCompleted: string[] = [];
  documentsSaved: any[] = [];

  displayedColumns: string[] = [
    'obligatorio',
    'tipoDocumento',
    'documento',
    'eliminar'
  ];
  dataSource: any[] = [
    { obligatorio: true, tipoDocumento: 'DNI_ANV' },
    { obligatorio: true, tipoDocumento: 'DNI_REV' },
    { obligatorio: true, tipoDocumento: 'PAYROLL' },
    { obligatorio: true, tipoDocumento: 'PAYROLL_CERTIFICATED' },
    { obligatorio: true, tipoDocumento: 'GDPR' },
    { obligatorio: false, tipoDocumento: 'GUARANTEE' }
  ];

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
    private dataEntryService: DataEntryService
  ) {
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }

    const timestamp = Date.now();
    this.nisTimestamp = this.user?.nis + timestamp;

    this.dataSource = this.filterDocumentsByUserCategory();
  }

  filterDocumentsByUserCategory(): any[] {
    if (this.user?.category === 'TMK' || this.user?.category === 'OMK') {
      return this.dataSource.filter((doc) => doc.tipoDocumento !== 'PAYROLL');
    } else {
      return this.dataSource.filter(
        (doc) => doc.tipoDocumento !== 'PAYROLL_CERTIFICATED'
      );
    }
  }

  getButtonStyle(): string {
    return this.isButtonDisabled()
      ? 'background-color: #565554'
      : 'background-color: #2c2a29';
  }

  isButtonDisabled(): boolean {
    return this.dataSource.some((doc) => doc.obligatorio && !doc.documento);
  }

  updateDocumentsTable(doc: any) {
    this.documentsCompleted.push(doc.documentType);
    this.documentsSaved.push(doc);
    const index = this.dataSource.findIndex(
      (d) => d.tipoDocumento === doc.documentType
    );
    if (index !== -1) {
      this.dataSource[index].documento = doc.fileName;
      this.cdr.detectChanges();
    }
  }

  backStep() {
    this.stepper?.selectedIndex === 0
      ? this.router.navigateByUrl('/menu')
      : this.backStepEmitter.emit();
  }

  uploadDocuments() {
    const dialogRef = this.dialog.open(DragDropComponent, {
      disableClose: true,
      data: {
        docs: this.documentsCompleted,
        nisTimestamp: this.nisTimestamp
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateDocumentsTable(result);
      }
    });
  }

  downloadGDPRDocument() {
    const documentPath = 'assets/documents/GDPR_2025.pdf'; // ruta donde está alojado el documento PDF
    const a = document.createElement('a');
    a.href = documentPath;
    a.download = 'GDPR.pdf';
    a.click();
  }

  sendRequest() {
    const docInfo = { tempId: this.nisTimestamp, docs: this.documentsSaved };
    this.sendRequestEmitter.emit(docInfo);
  }

  deleteDocument(doc: any) {
    const document = this.documentsSaved.find((d) => d.documentType === doc.tipoDocumento);
    if (document) {
      this.dataEntryService.deleteUploadedDocument(document.id).subscribe(
        () => {
          const index = this.documentsSaved.findIndex((d) => d.documentType === doc.tipoDocumento);
          if (index !== -1) {
            this.documentsSaved.splice(index, 1);
            this.documentsCompleted.splice(index, 1);
            this.dataSource[index].documento = null;
            this.cdr.detectChanges();
          }
          this.dataSource = this.filterDocumentsByUserCategory();
        },
        (error) => {
          console.error('Error deleting document:', error);
        }
      );
    }
  }
}
